import React, { useState } from 'react';
import s from './Variants.module.scss';
import { useRouter } from 'next/router';
import {
  OptionsType,
  ProductDescription,
  VariantUiType,
} from 'src/modules/parkplusStoreV2/types/product';
import useParkplusStoreV2 from 'src/modules/parkplusStoreV2/hooks/useParkplusStoreV2';
import { ProductDescriptionDataParent } from 'src/modules/parkplusStoreV2/types';
import { API_STATUS } from 'core-lib/constants/network';
import cn from 'classnames';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import { ChipsNFilter } from 'ui-v2/components/ChipsNFilter';
import { Typography } from 'ui-v2/components/Typography';

type VariantsPropType = {
  pdpdata: ProductDescription;
  updatePdpSlice?: (payload: any) => void;
};

const RenderOption = (data: OptionsType) => {
  switch (data?.uiType) {
    case VariantUiType.CARD:
      return (
        <div
          className={cn(s.card, {
            [s.selected]: data?.isDefault,
          })}
        >
          <AnimatedImage src={data?.value} alt="dataValue" />
          <Typography
            label={data?.option}
            variant="tiny_bold"
            color={data?.isDefault ? 'brand' : 'primary'}
          />
        </div>
      );

    case VariantUiType.CIRCLE:
      return (
        <div
          className={cn(s.circle, {
            [s.circleSelected]: data?.isDefault,
          })}
        >
          <AnimatedImage
            src={data?.value}
            className={s.color}
            alt="selectedimage"
          />
        </div>
      );

    default:
      return (
        <ChipsNFilter
          label={data.option}
          isActive={data?.isDefault ? true : false}
        />
      );
  }
};

export const Variants = ({ pdpdata, updatePdpSlice }: VariantsPropType) => {
  const [isDataPresent, setIsDataPresent] = useState(false);
  const {
    productDescriptions,
    productDescriptionData,
    productDescriptionDataApiStatus,
  } = useParkplusStoreV2();
  const router = useRouter();

  const getChildProductId = (obj: OptionsType, Selindex: number) => {
    //resulting key
    let str = '';
    pdpdata.configuration?.variants?.forEach((item, index) => {
      if (Selindex === index) {
        if (str.length > 0) str += '_';
        str += obj.option;
      } else {
        const res = item?.options.find((obj) => !!obj.isDefault);
        if (str.length > 0) str += '_';
        str += res.option;
      }
    });
    return pdpdata.configuration.childProductId[str];
  };
  const handleVariantClick = (obj: OptionsType, index: number) => {
    if (obj?.isDefault) return;

    const id = getChildProductId(obj, index);
    if (!productDescriptionData[id]) {
      setIsDataPresent(false);
      let payload: ProductDescriptionDataParent = {
        ...productDescriptions,
        data: {
          ...productDescriptionData,
          [id]: pdpdata,
        },
        apiStatus: API_STATUS.success,
      };
      updatePdpSlice(payload);
    } else {
      setIsDataPresent(true);
    }

    router.replace(
      {
        pathname: `${id}`,
        query: {
          lastSuccessProductId: `${pdpdata?.productId}`, //adding last sucessful in case api fails
        },
      },
      null,
      { shallow: true }
    );
  };

  if (!pdpdata?.configuration) return;

  return (
    <div className={s.root}>
      {pdpdata.configuration.variants.map((item, index) => (
        <div key={index} className={s.variant}>
          <Typography
            label={`${item?.label.toUpperCase()} :`}
            variant={"tiny_extended_bold"}
            color="secondary"
            className={s.title}
          />
          <div className={s.list}>
            {item?.options.map((obj, _index) => (
              <div
                key={_index}
                onClick={() => {
                  handleVariantClick(obj, index);
                }}
              >
                {RenderOption(obj)}
              </div>
            ))}
          </div>
        </div>
      ))}
      {!isDataPresent &&
        productDescriptionDataApiStatus === API_STATUS.in_progress && (
          <div className={s.block}>
            {/* <InlinePageLoader spinnerVariant="dark" /> */}
          </div>
        )}
    </div>
  );
};
